export default __webpack_public_path__ + "ce0b057f9bcd969c0cee5603a8357079.png";